module.exports = __webpack_public_path__ + "img/icon_4_38.97d38809.png";